import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { FLIGHT_REFUNDS_API_PATH } from "@/core/constants/apiEndPoints";
import {
  FetchFlightRefundPNRPayload,
  CalculateFlightRefundPNRPayload,
  CommitFlightRefundPNRPayload,
  FetchFlightRefundPNRResponse,
  CalculateFlightRefundPNRResponse,
  ActiveProvidersAndAirlinesRefundApiResponse,
} from "@/core/interfaces/IFlightRefunds.interface";

class FlightRedundsService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public fetchRefundPNR(
    params: FetchFlightRefundPNRPayload,
  ): Promise<ICoreResponse<ICoreResponse<FetchFlightRefundPNRResponse>>> {
    return this.restClient.post(FLIGHT_REFUNDS_API_PATH.FETCH_DETAILS, params);
  }
  public calculateRefundPNR(
    params: CalculateFlightRefundPNRPayload,
  ): Promise<ICoreResponse<ICoreResponse<CalculateFlightRefundPNRResponse>>> {
    return this.restClient.post(
      FLIGHT_REFUNDS_API_PATH.CALCULATE_DETAILS,
      params,
    );
  }
  public commitRefundPNR(
    params: CommitFlightRefundPNRPayload,
  ): Promise<ICoreResponse> {
    return this.restClient.post(FLIGHT_REFUNDS_API_PATH.COMMIT, params);
  }
  public getActiveRefundProviders(
    organization_id: string,
  ): Promise<
    ICoreResponse<ICoreResponse<ActiveProvidersAndAirlinesRefundApiResponse>>
  > {
    return this.restClient.get(
      FLIGHT_REFUNDS_API_PATH.GET_ACTIVE_PROVIDERS + organization_id,
    );
  }
}

export default FlightRedundsService;
